import { render, staticRenderFns } from "./LinkAvatar.vue?vue&type=template&id=d4cf2b54"
import script from "./LinkAvatar.vue?vue&type=script&lang=js"
export * from "./LinkAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports